import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import AppGrid from '../components/AppGrid';
import About from '../components/About';
import Footer from '../components/Footer';

const Home: React.FC = () => {
    return (
        <div id="top" className="min-h-screen bg-[#f5f5f7] dark:bg-[#0B0B0F] font-sans selection:bg-blue-100 selection:text-blue-900 dark:selection:bg-blue-900 dark:selection:text-white transition-colors duration-500">
            <Header />

            <main>
                <Hero />
                <AppGrid />
                <About />
            </main>

            <Footer />
        </div>
    );
};

export default Home;
